<div class="container">
    <div class="flex center column-gap-16">
        <div class="banner-text-container flex column">
            <h1 class="t-a-center">{{'landing-page.banner_title' | translateWithKeys}}</h1>
            <p class="t-a-center">{{'landing-page.banner_title_description' | translateWithKeys}}</p>
            <div class="flex column-gap-16 j-c-center">
                <button (click)="scrollTo('courses-section')" class="button courses flex" mat-stroked-button>
                    <div class="flex column-gap-8">
                        <span class="title2">{{'landing-page.banner_discover_courses_btn' | translateWithKeys}}</span>
                        <mat-icon class="arrow-right-fl" svgIcon="arrow_right_fl"></mat-icon>
                    </div>
                </button>
            </div>
        </div>
        <div class="image-container">
            <img class="banner-img" src="../../../assets/images/man-playing-football.jpg" alt="">
        </div>
    </div>
    <div class="flex center column section-size">
        <div class="flex center column row-gap-16">
            <h2 class="t-a-center">{{'landing-page.banner_subtitle' | translateWithKeys}}</h2>
            <p class="align-text-center text-balance">{{'landing-page.banner_subtitle_description' | translateWithKeys}}</p>
        </div>
        <div class="cards-container flex">
            <div class="card">
                <mat-icon svgIcon="diamond"></mat-icon>
                <h4>{{'landing-page.banner_card_one_title' | translateWithKeys}}</h4>
                <p>{{'landing-page.banner_card_one_description' | translateWithKeys}}</p>
            </div>
            <div class="card">
                <mat-icon svgIcon="mobile_device"></mat-icon>
                <h4>{{'landing-page.banner_card_two_title' | translateWithKeys}}</h4>
                <p>{{'landing-page.banner_card_two_description' | translateWithKeys}}</p>
            </div>
            <div class="card">
                <mat-icon svgIcon="lightning"></mat-icon>
                <h4>{{'landing-page.banner_card_three_title' | translateWithKeys}}</h4>
                <p>{{'landing-page.banner_card_three_description' | translateWithKeys}}</p>
            </div>
            <div class="card">
                <mat-icon svgIcon="medal"></mat-icon>
                <h4>{{'landing-page.banner_card_four_title' | translateWithKeys}}</h4>
                <p>{{'landing-page.banner_card_four_description' | translateWithKeys}}</p>
            </div>
        </div>
    </div>
</div>
